import layoutHeaderAside from '@/layout'

import e_base from './modules/ecom/base'
import awsImport from './modules/ecom/awsImport'
import evgImport from './modules/ecom/evgImport'
import awsReport from './modules/ecom/awsReport'
import awsBiz from './modules/ecom/awsBiz'
import evgBiz from './modules/ecom/evgBiz'
import ecomSys from './modules/ecom/ecomSys'
import hxBiz from './modules/ecom/hxBiz'
import awsSample from './modules/ecom/awsSample'
import ecomTool from './modules/ecom/ecomTool'
import approvalCenter from './modules/ecom/approval-center'
import shipment_management from './modules/ecom/shipment-management'
// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    component: layoutHeaderAside,
    children: [
      // 首页
      {
        path: '/',
        alias: '/ecom',
        name: 'index',
        meta: {
          auth: true,
          funcID: 'E00',
          PID: 'E00',
          head: true,
          title: '首页',
        },
        component: _import('ecom'),
      },
      {
        path: '/403',
        name: '403',
        meta: {
          title: '无权限访问',
        },
        component: _import('system/403'),
      },
    ],
  },
  e_base,
  awsImport,
  evgImport,
  awsReport,
  awsBiz,
  evgBiz,
  ecomSys,
  hxBiz,
  awsSample,
  ecomTool,
  approvalCenter,
  shipment_management,
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    meta: {
      funcID: 'LOGIN',
    },
    component: _import('system/login'),
  },
  {
    path: '/opview/amzExpense/:code',
    name: `opview-amzExpense`,
    meta: {
      auth: false,
      title: '订单费用单详情',
    },
    component: _import('ecom/h5View/amzExpense'),
  },
  {
    path: '/opview/evgExpense/:code',
    name: `opview-evgExpense`,
    meta: {
      auth: false,
      title: 'EVG费用填报详情',
    },
    component: _import('ecom/h5View/evgExpense'),
  },
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  // ...errorPage
]
